export default __webpack_public_path__ + "static/BatisseurDAvenir-7d845c95f0001d895263e782519d6855.png";